import { FC } from "react";

import { RHookFormNumberField } from "@websential/cosmic-v20";
import { Box, Typography } from "@mui/material";

interface IProvisionalVariableForQCSetupFieldsPanel {}
export const ProvisionalVariableForQCSetupFieldsPanel: FC<
	IProvisionalVariableForQCSetupFieldsPanel
> = ({}) => {
	return (
		<div>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					marginBottom: "35px",
					// justifyContent:"center"
				}}
			>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					Annual Federal tax Deduction T1 = [( T3 - LFC - (&nbsp;
				</Typography>
				<Box sx={{ "& .numberFieldWrapper": { marginBottom: "0 !important" } }}>
					<RHookFormNumberField
						id={"annualFederalTaxDeductionT1"}
						testId={`annualFederalTaxDeductionT1`}
						minFractionDigits={4}
						maxFractionDigits={10}
					/>
				</Box>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					&nbsp;* T3 )]
				</Typography>
			</Box>

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					marginBottom: "35px",
					// justifyContent:"center"
				}}
			>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					Deduction for employment income H = (&nbsp;
				</Typography>
				<Box sx={{ "& .numberFieldWrapper": { marginBottom: "0 !important" } }}>
					<RHookFormNumberField
						id={"deductionForEmploymentIncomeH"}
						testId={`deductionForEmploymentIncomeH`}
						minFractionDigits={4}
						maxFractionDigits={10}
					/>
				</Box>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					&nbsp;* D ) , maximum of (&nbsp;
				</Typography>
				<Box sx={{ "& .numberFieldWrapper": { marginBottom: "0 !important" } }}>
					<RHookFormNumberField
						id={"deductionForEmploymentIncomeHMaximumOf"}
						testId={`deductionForEmploymentIncomeHMaximumOf`}
						minFractionDigits={4}
						maxFractionDigits={10}
					/>
				</Box>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					&nbsp;/ P)]
				</Typography>
			</Box>

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					marginBottom: "35px",
					// justifyContent:"center"
				}}
			>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					Quebec Income tax for the year Y = (T * I) - K - K1 - (&nbsp;
				</Typography>
				<Box sx={{ "& .numberFieldWrapper": { marginBottom: "0 !important" } }}>
					<RHookFormNumberField
						id={"quebecIncomeTaxForTheYearY1"}
						testId={`quebecIncomeTaxForTheYearY1`}
						minFractionDigits={4}
						maxFractionDigits={10}
					/>
				</Box>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					&nbsp;* E) - (&nbsp;
				</Typography>
				<Box sx={{ "& .numberFieldWrapper": { marginBottom: "0 !important" } }}>
					<RHookFormNumberField
						id={"quebecIncomeTaxForTheYearY2"}
						testId={`quebecIncomeTaxForTheYearY2`}
						minFractionDigits={4}
						maxFractionDigits={10}
					/>
				</Box>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					&nbsp;* P * Q ) - (&nbsp;
				</Typography>
				<Box sx={{ "& .numberFieldWrapper": { marginBottom: "0 !important" } }}>
					<RHookFormNumberField
						id={"quebecIncomeTaxForTheYearY3"}
						testId={`quebecIncomeTaxForTheYearY3`}
						minFractionDigits={4}
						maxFractionDigits={10}
					/>
				</Box>
				<Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
					&nbsp;* P * Q1 )
				</Typography>
			</Box>
		</div>
	);
};
